import { useMutation } from '@tanstack/react-query';

import { fieldMapsApi } from '../../apis/field-maps';

export function useProcessYieldMap() {
  return useMutation({
    mutationFn: fieldMapsApi.processYieldMap,
  });
}

export default useProcessYieldMap;
